import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import './i18n'; // 初始化 i18n
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import Home from './pages/Home';
import DailyReportPage from './pages/DailyReport/DailyReportPage';
import DailyReportForm from './pages/DailyReport/DailyReportForm';
import SiteSlumpPage from './pages/SiteSlump/SiteSlumpPage';
import RFIDManagement from './pages/RFID/RFIDManagement';
import RFIDMultiEdit from './pages/RFID/RFIDMultiEdit';
import MixIDPage from './pages/MixID/MixIDPage';
import ApiTest from './pages/ApiTest';
import ContractDataPage from './pages/ContractData/ContractDataPage';
import TaskPage from './pages/MixID/TaskPage';
import First3End3Page from './pages/First3End3/First3End3Page';
import SlumpBirthPaperPage from './pages/SiteSlump/SlumpBirthPaperPage';
import UserManagementPage from './pages/Settings/UserManagementPage';
import SettingsPage from './pages/Settings/SettingsPage';
import ChangePasswordPage from './pages/Settings/ChangePasswordPage';
import TimeRangeSettingsPage from './pages/Settings/TimeRangeSettingsPage';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00BFFF',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Microsoft JhengHei", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/api-test" element={<ApiTest />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/home" element={<Home />} />
                      <Route path="/daily-report" element={<DailyReportPage />} />
                      {/* <Route path="/daily-report/form" element={<DailyReportForm />} /> */}

                      <Route path="/site-slump/slump-birth-paper" element={<SlumpBirthPaperPage />} />
                      <Route path="/site-slump" element={<SiteSlumpPage />} />
                      <Route path="/contract-data" element={<ContractDataPage />} />
                      <Route path="/rfid" element={<RFIDManagement />} />
                      <Route path="/rfid/multi-edit" element={<RFIDMultiEdit />} />
                      <Route path="/mixid" element={<MixIDPage />} />
                      <Route path="/mixid/tasks" element={<TaskPage />} />
                      <Route path="/first3-end3" element={<First3End3Page />} />
                      <Route path="/user-management" element={<UserManagementPage />} />
                      <Route path="/settings" element={<SettingsPage />} />
                      <Route path="/change-password" element={<ChangePasswordPage />} />
                      <Route path="/time-settings" element={<TimeRangeSettingsPage />} />
                      {/* 其他受保護的路由可以在這裡添加 */}
                    </Routes>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;